import { type CellState } from '@apps/web/features/coverage/model/coverage_types';

/**
 * Cell-state encodings are never hue-only: each state pairs its color
 * with a distinct fill treatment (solid / half fill / stripes / outline
 * wash / dotted outline) so the grid stays readable for color-blind
 * users and in print.
 */
export const CELL_STATE_CLASSES: Record<CellState, string> = {
    available: 'bg-emerald-500',
    partially_available:
        'bg-[linear-gradient(to_right,var(--color-emerald-500)_0%,var(--color-emerald-500)_50%,var(--color-emerald-200)_50%,var(--color-emerald-200)_100%)]',
    scheduled:
        'bg-[repeating-linear-gradient(45deg,var(--color-blue-500)_0px,var(--color-blue-500)_2px,var(--color-blue-200)_2px,var(--color-blue-200)_4px)]',
    unavailable: 'border border-red-400 bg-red-100',
    unknown: 'border border-dashed border-muted-foreground/50 bg-transparent',
};

export const CELL_STATE_LEGEND_ORDER: ReadonlyArray<CellState> = [
    'available',
    'partially_available',
    'scheduled',
    'unavailable',
    'unknown',
];
